import { get } from 'lodash';
import { createSelector } from 'reselect';

import { getEntities, selectLocation, getQueries, getErrors, selectSearchObj } from '../../global-selectors';
import urlHelper from '../../domain/UrlHelper';
import { selectCurrentContentId } from './contents';
import { findLastQueryByRouteMatch } from '../../utils/query';

export const selectCurrentPaymentMethod = createSelector(
  selectLocation,
  selectSearchObj,
  (location, searchObj) => {
    const params = location.pathname.split('/');
    const pathMethod = params[1].toLowerCase() === 'ppv'
    ? params[5]
    : params[4];

  if (pathMethod) {
    return pathMethod;
  }
  if (searchObj && searchObj.method) {
    return Array.isArray(searchObj.method) ? searchObj.method[0] : searchObj.method;
  }
  return null;
  },
);

export const selectCurrentCustomerPaymentProfileId = createSelector(
  selectLocation,
  location => {
    const params = location.pathname.split('/');
    return params[1].toLowerCase() === 'ppv'
      ? params[6]
      : params[5];
  },
);

export const selectCurrentContentPPVId = createSelector(
  getEntities,
  selectCurrentContentId,
  (entities, currentContentId) => (entities.contents && entities.contents[urlHelper.extractContentIdFromPath(currentContentId)])
    ? entities.contents[urlHelper.extractContentIdFromPath(currentContentId)].ppvConfig.ppvId
    : null
);

export const selectPaymentMethods = createSelector(
  getEntities,
  entities => get(entities, 'bootstrap.supportedMethods', [])
    .filter(method => method.web)
);

export const selectPaymentMethodsWithoutAffiliates = createSelector(
  getEntities,
  entities => get(entities, 'bootstrap.supportedMethods', [])
    .filter(method => method.web && method.name !== 'affiliates')
);

const AVAILABLE_PAYMENT_METHODS = ['stripe', 'kushki', 'efecty'];

export const selectPaymentConfig = createSelector(
  getEntities,
  selectCurrentPaymentMethod,
  (entities, methodID) => {
  let paymentMethod = methodID;
  // TODO: only allows stripe as new payment method
  if (!AVAILABLE_PAYMENT_METHODS.includes(methodID)) {
      paymentMethod = 'stripe';
  }
    return get(entities, `paymentConfigs.${paymentMethod}`, {})
  }
);

export const selectAllSubPaymentMethodsConfig = createSelector(
  getEntities,
  (entities) => get(entities, 'subPaymentMethods', [])
);

export const selectShouldChangeFavoritePaymentMethod = createSelector(
  getEntities,
  (entities) => get(entities, 'shouldChangeFavoritePaymentMethod', false)
);

export const selectSubPaymentConfig = createSelector(
  getEntities,
  selectCurrentPaymentMethod,
  (entities, methodID) => get(entities, `subPaymentMethods.${methodID}`, null)
);

export const selectCurrentSubPaymentMethod = createSelector(
  getEntities,
  selectCurrentPaymentMethod,
  (entities) => {
    return get(entities, `currentSubPaymentMethod`, null)
  }
);

export const selectDiscountCodeLoading = createSelector(
  getQueries,
  (queries) => {
    const [, result] = findLastQueryByRouteMatch(queries, 'discount-code') || [];
    return get(result, 'isPending', false);
  }
);

export const selectDiscountCodeErrors = createSelector(
  getErrors,
  (errors) => {
    const [, result] = findLastQueryByRouteMatch(errors, 'discount-code') || [];

    if (get(result, 'responseBody.status') < 400) {
      return null;
    }

    return get(result, 'responseBody', null);
  }
);
